import { MessageService } from 'primeng/components/common/api';
import { CustomerDetailLoyaltyInfoComponent } from './../customers/loyaltyinfo/loyaltyinfo.component';
import { CustomerInfoService } from './../../../services/customer/customerinfo.service';
import { Permission } from './../../../models/permission.model';
import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { MenuItem } from 'primeng/primeng';
import { CustomerBasicInfo, CustomerCompanyData } from '../../../models/customer.model';
import { FormValidationService } from '../../../services/utils/form-validation.service';
import { CustomerClustersComponent } from '../customer-clusters/customer-clusters.component';
import { CustomerCompanyAddressComponent } from './customer-company-address/customer-company-address.component';
import { CustomerCompanyBasicComponent } from './customer-company-basic/customer-company-basic.component';
import { CustomerCompanyBasicNewComponent } from './customer-company-basic-new/customer-company-basic-new.component';
import { ApiMethods, PermissionConfiguration} from '../../../models/permission.model';
import { Observable } from 'rxjs';
import { PermsService } from '../../../services/utils/perms.service';
import { UploadmgCompany } from '../customers/upload-mg-company/uploadmgcompany.component';
import { CustomerCardListModel } from 'app/models/customer-cards.model';

@Component({
  selector: 'app-customer-company',
  templateUrl: './customer-company.component.html',
  styleUrls: ['./customer-company.component.css']
})
export class CustomerCompanyComponent implements OnInit {
  @ViewChild(CustomerCompanyBasicComponent) customerBasic: CustomerCompanyBasicComponent;
  @ViewChild(CustomerCompanyBasicNewComponent) customerBasicNew: CustomerCompanyBasicNewComponent;
  @ViewChild(CustomerCompanyAddressComponent) customerAddress: CustomerCompanyAddressComponent;
  @ViewChild(CustomerClustersComponent) customerClusters: CustomerClustersComponent;
  @ViewChild(UploadmgCompany) uploadCompanyModule: UploadmgCompany;
  @ViewChild(CustomerDetailLoyaltyInfoComponent) customerDetailLoyaltyInfo: CustomerDetailLoyaltyInfoComponent;

  customerId: string;
  customer_id: string;
  editMode: boolean;
  activeIndex: number;
  errorOnSave: boolean;
  validationForm: boolean;
  items: MenuItem[];

  show = {
    loyaltyInfo: false,
    basic: false,
    uploadModule: false,
    permissions: false
  }

  noCardsForCustomer: boolean = false;

  public basicInfo: CustomerBasicInfo = null;
  public companyInfo: CustomerCompanyData = null;
  public cardInfo: CustomerCardListModel[] = [];
  public myCustomerCode: string = null;

  private dirtyFormData: boolean = false;
  private clusterChanged: boolean = false;
  private clusterQty: number;

  cards: CustomerCardListModel[];
  missingClusterMsg: string;
  saveClusterMsg: string;
  dataLossMsg: string;
  titlePage: string;

  public customerPermissions: Array<Permission>;
  public loyaltyPermissions: Array<Permission>;

  // Switch tra componenti generali e componenti specifici
  public customerMgPermission: boolean;
  public customerMgPermissionCheck: PermissionConfiguration;


  // Per indicare alla UI se deve considerare KLOY
  public customerKloyPermission: boolean;
  public customerKloyPermissionCheck: PermissionConfiguration;

  // Permission CRUD per Coupon Manager
  public couponManagerPermission: boolean;
  public couponManagerPermissionCheck: PermissionConfiguration;

  customerHasFiles: boolean;
  customerHasLoginAccount: boolean;

  constructor (
    private route: ActivatedRoute,
    private transtateService: TranslateService,
    private srvValidation: FormValidationService,
    private location: Location,
    private confirmationService: ConfirmationService,
    private customerInfoSrv: CustomerInfoService,
    private srvPerms: PermsService,
    private router: Router,
    private srvNotify: MessageService,
  ) {
    this.customerMgPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-mg',
      method: ApiMethods.GET
    };

    this.customerKloyPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-kloy',
      method: ApiMethods.GET
    };

    this.couponManagerPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-coupon',
      method: ApiMethods.GET
    };
  }

  ngOnInit() {
    this.customerId = this.route.snapshot.params['customerId'];
    this.customer_id = this.route.snapshot.params['customer_id'] || null;
    this.editMode = this.customerId !== undefined;
    this.customerKloyPermission = false;
    this.customerMgPermission = false;
    this.couponManagerPermission = false;

    this.validationForm = true;
    this.activeIndex = 0;

    if (this.editMode) {
      this.titlePage = 'customerCompany.edit';

      // Verifica che il cliente selezionato abbia un account di login
      this.customerInfoSrv.getCustomerAuthInfo(+this.customerId).subscribe(res => {
        if (res) {
          this.customerHasLoginAccount = true;
        }
      });

    } else {
      this.titlePage = 'customerCompany.addNew';
    }

    var LOYALTYPERMISSIONS = this.srvPerms.getLoyaltyPermission();
    var CUSTOMERPERMISSIONS = this.srvPerms.getCustomerPermission();
    var CARDS =   this.customerInfoSrv.getCards(this.customerId);

    Observable.zip(this.transtateService.get([
      'customerCompany.companyData',
      'customerCompany.addresses',
      'customerInfoSheet.cardsInfo',
      'customerInfoSheet.clustersInfo',
      'customerInfoSheet.customerModuleInfo',
      'customerInfoSheet.missingClusterMsg',
      'customerInfoSheet.saveClusterMsg',
      'customerInfoSheet.dataLossMsg',
      'customerInfoSheet.couponManager'
    ]),
    LOYALTYPERMISSIONS,
    CUSTOMERPERMISSIONS,
    CARDS
    //this.srvPerms.check(this.customerMgPermissionCheck)
    ).subscribe(([
      res,
      resLoyaltyPermissions,
      resCustomerPermissions,
      resCards,
//      mgPermissionCheck
    ]) => {
      this.items = [{
        label: res['customerCompany.companyData'],
        command: (event: any) => {
          this.activeIndex = 0;
        }
      }];

      if(resCards && resCards.length>0){
        this.cards = resCards;
      }

      this.missingClusterMsg = res['customerInfoSheet.missingClusterMsg'];
      this.saveClusterMsg = res['customerInfoSheet.saveClusterMsg'];
      this.dataLossMsg = res['customerInfoSheet.dataLossMsg'];

      this.customerPermissions = resCustomerPermissions;
      this.loyaltyPermissions = resLoyaltyPermissions;
      this.show.loyaltyInfo = true;

      this.customerMgPermission = this.srvPerms.checkPermission(this.customerPermissions,this.customerMgPermissionCheck);
      this.customerKloyPermission = this.srvPerms.checkPermission(this.customerPermissions,this.customerKloyPermissionCheck);

      this.couponManagerPermission = this.srvPerms.checkPermission(this.customerPermissions, this.couponManagerPermissionCheck);

      this.show.permissions = true;

      if (this.editMode) {

        if(this.customerMgPermission){
          //Gabrielli non vuole il tab "Indirizzi" e vuole un tab in più "Moduli"
          this.items.push(
            {
              label: res['customerInfoSheet.cardsInfo'],
              command: (event: any) => {
                this.activeIndex = 1;
              }
            },
            {
              label: res['customerInfoSheet.clustersInfo'],
              command: (event: any) => {
                this.activeIndex = 2;
              }
            },
            {
              label: res['customerInfoSheet.customerModuleInfo'],
              command: (event: any) => {
                this.activeIndex = 3;
              }
            });
        }
        else{
          this.items.push(
            {
              label: res['customerCompany.addresses'],
              command: (event: any) => {
                this.activeIndex = 1;
              }
            },
            {
              label: res['customerInfoSheet.cardsInfo'],
              command: (event: any) => {
                this.activeIndex = 2;
              }
            },
            {
              label: res['customerInfoSheet.clustersInfo'],
              command: (event: any) => {
                this.activeIndex = 3;
              }
            });
        }

        if (this.couponManagerPermission){
          this.items.push({
            label: res['customerInfoSheet.couponManager'],
            command: (event: any) => {
              this.activeIndex = this.customerMgPermission ? 4 : 5;
            }
          });
        }

      }
      this.show.basic = true;
      this.show.uploadModule = true;
    });

    /*this.transtateService.get([
      'customerCompany.companyData',
      'customerCompany.addresses',
      'customerInfoSheet.cardsInfo',
      'customerInfoSheet.clustersInfo',
      'customerInfoSheet.missingClusterMsg',
      'customerInfoSheet.saveClusterMsg',
      'customerInfoSheet.dataLossMsg'
    ]).subscribe(res => {
      this.items = [{
        label: res['customerCompany.companyData'],
        command: (event: any) => {
          this.activeIndex = 0;
        }
      }];

      this.missingClusterMsg = res['customerInfoSheet.missingClusterMsg'];
      this.saveClusterMsg = res['customerInfoSheet.saveClusterMsg'];
      this.dataLossMsg = res['customerInfoSheet.dataLossMsg'];

      if (this.editMode) {
        this.items.push(
          {
            label: res['customerCompany.addresses'],
            command: (event: any) => {
              this.activeIndex = 1;
            }
          },
          {
            label: res['customerInfoSheet.cardsInfo'],
            command: (event: any) => {
              this.activeIndex = 2;
            }
          },
          {
            label: res['customerInfoSheet.clustersInfo'],
            command: (event: any) => {
              this.activeIndex = 3;
            }
          });
      }
    });*/
  }

  /**
   * Save method for saving both Basic customer data and Address data.
   */
   domiciliationDone(){
     if(this.customerMgPermission){
      this.show.basic = false;
      this.show.uploadModule = false;
      var self = this;
      setTimeout(function(){
        self.show.basic = true;
        self.show.uploadModule = true;
      },100);
     }
  }

  /* utilizzato (solo in Gabrielli) per la visualizzazione del pulsante sostituisci carta nel tab Carte.
  Il pulsante verrà visualizzato solo se tutti i campi obbligatori della scheda cliente sono presenti */
  allMandatoryFieldsOkLoaded(isOk:boolean){
    if(isOk==true){
      this.customerDetailLoyaltyInfo.allCustomerMandatoryFieldsOk = true;
    }
  }

  /**
   * In Gabrielli, se il cliente non ha un account di login, è obbligatorio il caricamento di un modulo (KS-3066)
   */
   checkCustomerLogin() {
    if (this.customerMgPermission && !this.customerHasLoginAccount && !this.customerHasFiles) {
      this.confirmationService.confirm({
        message: this.transtateService.instant('customers.fileRequiredMsg'),
        accept: () => this.save(),
        acceptLabel: this.transtateService.instant('common.yes'),
        rejectVisible: true,
        rejectLabel: 'NO',
        reject: () => false
      });
    } else {
      this.save();
    }
  }

  save() {
    if ((this.checkActiveCard() && this.clusterQty == 0) && !this.customerMgPermission) {
      this.confirmationService.confirm({
        message: this.missingClusterMsg,
        accept: () => false,
        acceptLabel: 'Ok',
        rejectVisible: false
      });
      return;
    }

    if(this.customerMgPermission){
      if (!this.customerBasicNew.formData.valid) {
        this.activeIndex = 0;
        this.srvValidation.validateAllFormFields(this.customerBasicNew.formData);
        return;
      }

      // !!! questo if è fondamentale per il corretto funzionamento del savataggio.
      // !!! se customer address è FALSE è perchè ci troviamo nella condizione in cui
      // !!! stiamo CREANDO una company. in questa fase NON SONO RICHIESTI GLI INDIRIZZI.
      // per come è concepito attualmente il componente, quindi, gli indirizzi SONO NULL!!!
      if (this.customerAddress) {
        if (!this.customerAddress.form.valid) {
          this.activeIndex = 1;
          this.srvValidation.validateAllFormFields(this.customerAddress.form);
          return;
        }

        // loop over FormArray of CustomerCompanyAddressComponent and saving them.
        let i = 0;
        for (const address of this.customerAddress.addresses.controls) {
          // save address (AbstractControl as FormGroup)
          this.customerAddress.saveAddress(i, address as FormGroup);
          i++;
        }
      }

      this.customerBasicNew.saveMg();
    }else{
      if (!this.customerBasic.form.valid) {
        this.activeIndex = 0;
        this.srvValidation.validateAllFormFields(this.customerBasic.form);
        this.customerBasic.invalidSubmit = true;
        return;
      }

      // !!! questo if è fondamentale per il corretto funzionamento del savataggio.
      // !!! se customer address è FALSE è perchè ci troviamo nella condizione in cui
      // !!! stiamo CREANDO una company. in questa fase NON SONO RICHIESTI GLI INDIRIZZI.
      // per come è concepito attualmente il componente, quindi, gli indirizzi SONO NULL!!!
      if (this.customerAddress) {
        if (!this.customerAddress.form.valid) {
          this.activeIndex = 1;
          this.srvValidation.validateAllFormFields(this.customerAddress.form);
          return;
        }

        // loop over FormArray of CustomerCompanyAddressComponent and saving them.
        let i = 0;
        for (const address of this.customerAddress.addresses.controls) {
          // save address (AbstractControl as FormGroup)
          this.customerAddress.saveAddress(i, address as FormGroup);
          i++;
        }
      }

      this.customerBasic.save()
    }
  }

  basicInfoLoaded(basicInfo: CustomerBasicInfo) {
    this.basicInfo = basicInfo;
  }

  companyInfoLoaded(companyInfo: CustomerCompanyData) {
    this.companyInfo = companyInfo;
  }

  cardsInfoLoaded(cardInfo: CustomerCardListModel[]) {
    this.cardInfo = cardInfo;
  }

  myCustomerCodeLoaded(myCustomerCode: string) {
    this.myCustomerCode = myCustomerCode;
  }

  checkFormData(dirtyFormData: boolean) {
    this.dirtyFormData = dirtyFormData;
  }

  clusterChangedHandler(event) {
    this.clusterChanged = event;
  }

  clusterListChangedHandler(event) {
    this.clusterQty = event.length;
  }
  reloadTabUploadModules(){
    if(this.customerMgPermission){
      this.show.uploadModule = false;
      var self = this;
      setTimeout(function(){
        self.show.uploadModule = true;
      },100);
    }
  }
  cardSubstitutionDone(){
    //a seguito della sostituzione di una carta ricarica il modulo upload
    this.reloadTabUploadModules();
  }
  cardBlacklistDone(){
    //a seguito della blacklist di una carta ricarica il modulo upload
    this.reloadTabUploadModules();
  }
  cardAddDone(){
    //a seguito dell'aggiunta di una carta ricarica il modulo upload
    this.reloadTabUploadModules();
  }
  noCardLinked(){
    /*
    se non ci sono carte collegate al cliente, si deve informare l'utente, ma non farlo agire sulla scheda
    si torna quindi alla lista clienti
    */
   if(this.noCardsForCustomer == false && this.customerMgPermission){
    this.noCardsForCustomer = true;
    var self = this;
    this.transtateService.get(['card.notAvailable']).subscribe(res => {

    this.srvNotify.add({ severity: 'error', summary: 'Error!', detail: res['card.notAvailable']})
      setTimeout(function(){
        self.router.navigate(['/customers-infosheet-new']);
      },200);
    });
   }
  }
  confirm() {

    /*
    CASO FLUSSO GABRIELLI:
    non c'è bisogno di controlli su cluster.
    Gabrielli visualizza solo i cluster senza possibilità di aggiungere, modificare o eliminare.
    Bisogna solo salvare eventuali cambiamenti per l'allineamento con KLOY
    */
    if(this.customerMgPermission){
      if (this.dirtyFormData) {
        this.confirmationService.confirm({
          message: this.dataLossMsg,
          accept: () => this.location.back(),
          acceptLabel: 'Ok',
          rejectLabel: 'Annulla',
          rejectVisible: true
        })
      } else {
        if(this.basicInfo)
          this.router.navigate(['/customers-infosheet-new'], { queryParams: { customerCode: this.basicInfo.customerCode } });
        else
          this.location.back();
      }
    }
    else{
      /*
      CASO FLUSSO NORMALE:
      c'è bisogno di aggiungere almeno un cluster e salvare in caso di cambiamenti
      */
      if (this.checkActiveCard() && this.clusterQty == 0) {
        this.confirmationService.confirm({
          message: this.missingClusterMsg,
          accept: () => false,
          acceptLabel: 'Ok',
          rejectVisible: false
        })
      } else if (this.clusterChanged) {
        this.confirmationService.confirm({
          message: this.saveClusterMsg,
          accept: () => false,
          acceptLabel: 'Ok',
          rejectVisible: false
        })
      } else if (this.dirtyFormData) {
        this.confirmationService.confirm({
          message: this.dataLossMsg,
          accept: () => this.location.back(),
          acceptLabel: 'Ok',
          rejectLabel: 'Annulla',
          rejectVisible: true
        })
      } else {
        this.location.back();
      }
    }
  }

  checkActiveCard() {
    let active = false;
    if (this.cards && this.cards.length > 0) {
      this.cards.forEach(card => {
        if(card.flagBlackList == "0") {
          active = true
          return
        }   
      })
    }
    return active;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-company/customer-company.component.ts